<template>
    <div>
        <v-navigation-drawer 
            app
            permanent
            clipped
            color="secondary"
            width="300px"
            class="pt-6"
            v-bind="$attrs"
        >
            <div class="px-5">
                <SidebarDateTime></SidebarDateTime>
                <!-- <div
                    class="align-items-center clickable my-3"
                >
                    <v-icon x-small color="primary">mdi-circle</v-icon>
                    <span class="font-weight-bold primary--text">
                        Create Case from PMS
                    </span>
                </div> -->
                <!-- <CreatePMSCase></CreatePMSCase> -->

                <br><hr />

                <!-- <SidebarCaseFilter></SidebarCaseFilter> -->
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
export default {
    components: {
        SidebarDateTime: () => import("./SidebarDateTime"),
        // SidebarCaseFilter: () => import("./SidebarCaseFilter"),
        /*CreatePMSCase: () => import("../partials/CreatePMSCase")*/
    },
    data: () => ({
    }),
    // computed: {
    //     cases() {
    //         return this.$store.getters['cases/cases']
    //     },
    // },
    mounted() {
        // console.log({ cases: this.cases });
    }
}
</script>